import styled from "styled-components";
import FilterOption from "./FilterOption";
import { useState } from "react";
import GradientButton from "../GradientButton";

const StyledFilterSection = styled.div`
    width: 320px;
    background: #1C1C1C;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    margin: 0px;
    overflow-y: scroll;
    padding-top: 20px;

    html {
      overflow: scroll;
    }

    ::-webkit-scrollbar {
      width: 0px;
      background: transparent; /* make scrollbar transparent */
    }

    #filter-controls {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 25px;
        padding-right: 25px;
        padding-top: 10px;    
      
        #clear-all-button {
          color: #38ef7d;
          text-decoration: underline;
          font-size: 16px;
          font-weight: 400;
          line-height: 19.2px;
          cursor: pointer;
        }
    }

    #apply-filters-button {
        margin: 20px 0px 20px 0px;
        width: 246px;
        height: 47px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 14px;
        background: linear-gradient(#38ef7d, #11998e);
        color: #ffffff;
    }

    .filter-option-text {
      margin: 0px;
      flex: 2;
    }    

    .accordion-tile {
      padding-left: 24px;
      padding-right: 24px;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      p {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        color: #ffffff;
        margin: 0px;
      }

      .accordion-header {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }

    .filter-selector {
      width: 246px;
      margin: 10px 20px 24px 20px;
      height: 37px;
      border-radius: 20px;
      background: #ffffff0d;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-left: 16px;
      padding-right: 16px;
      border-width: 1px;
      border-color: #ffffff1a;
      border-style: solid;

      p {
        margin: 0px;
        font-size: 14px;
        font-weight: 400;
        line-height: 19px;
        color: #a6a6a6;
      }
    }

    #filter-controls {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .filter-option-radio {
      padding: 10px 20px 10px 20px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
    }

    #end-tile {
      height: 200px;
      width: 100%;
      background: linear-gradient(#1C1C1C, #000000);
    }
`;

export default function FilterSection({onFilterChanged}) {

  const [selectedCategories, setSelectedCategories] = useState([]);

  function onCategorySelect(category){
    //adding or removing the category    
    if(selectedCategories.includes(category)){      
      setSelectedCategories([...selectedCategories.filter((element)=>element !== category)]);
    }else{   
      setSelectedCategories([...selectedCategories, category]);
    }
  }

  function onApplyFilters(){
    onFilterChanged(selectedCategories);
  }

  function onClearAll(){
    onFilterChanged([]);
  }

  return (
    <StyledFilterSection>
      <div id="filter-controls">
        <p>Filter</p>
        <div id="clear-all-button" onClick={onClearAll}>Clear All</div>
      </div>      
      <div className="accordion-tile">
        <div className="accordion-header">
          <p>Categories</p>
          <svg
            width="14"
            height="9"
            viewBox="0 0 14 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.78125 8.52344C6.58333 8.52344 6.40625 8.44792 6.25 8.29688L0.203125 2.10938C0.135417 2.04167 0.0833333 1.96615 0.046875 1.88281C0.0104167 1.79427 -0.0078125 1.70052 -0.0078125 1.60156C-0.0078125 1.46615 0.0234375 1.34375 0.0859375 1.23438C0.148438 1.125 0.231771 1.03906 0.335938 0.976562C0.445312 0.914062 0.567708 0.882812 0.703125 0.882812C0.901042 0.882812 1.07031 0.950521 1.21094 1.08594L7.19531 7.20312H6.35938L12.3438 1.08594C12.4896 0.950521 12.6589 0.882812 12.8516 0.882812C12.987 0.882812 13.1068 0.914062 13.2109 0.976562C13.3203 1.03906 13.4062 1.125 13.4688 1.23438C13.5312 1.34375 13.5625 1.46615 13.5625 1.60156C13.5625 1.79427 13.4922 1.96094 13.3516 2.10156L7.30469 8.29688C7.23698 8.36979 7.15625 8.42708 7.0625 8.46875C6.97396 8.50521 6.88021 8.52344 6.78125 8.52344Z"
              fill="white"
            />
          </svg>
        </div>
        <div className="filter-option-radio">
          <FilterOption onSelect={()=>onCategorySelect('rent')} isSelected={selectedCategories.includes('rent')} optionText={"Rent"}></FilterOption>
        </div>
        <div className="filter-option-radio">
          <FilterOption onSelect={()=>onCategorySelect('0x2bcbb73c73d765a695f972bdd84222ee8ee55f2d')} isSelected={selectedCategories.includes('0x2bcbb73c73d765a695f972bdd84222ee8ee55f2d')} optionText={"Qorbs"}></FilterOption>
        </div>
        <div className="filter-option-radio">
          <FilterOption onSelect={()=>onCategorySelect('0xcd05e79857c1c0eb1eeaf1573a12c25d411e0757')} isSelected={selectedCategories.includes('0xcd05e79857c1c0eb1eeaf1573a12c25d411e0757')} optionText={"QorX Pass"}></FilterOption>
        </div>
        <div className="filter-option-radio">
          <FilterOption onSelect={()=>onCategorySelect('0xb1dbf0fc711f268b3a3755f8171a9269d6d105fd')} isSelected={selectedCategories.includes('0xb1dbf0fc711f268b3a3755f8171a9269d6d105fd')} optionText={"Skins"}></FilterOption>
        </div>        
        <div className="filter-option-radio">
          <FilterOption onSelect={()=>onCategorySelect('0x7a6d3fb14a2eefd8173584a96abd2fafa08e396a')} optionText={"Pets"} isSelected={selectedCategories.includes('0x7a6d3fb14a2eefd8173584a96abd2fafa08e396a')}></FilterOption>
        </div>
      </div>      
      <GradientButton onTap={onApplyFilters} text={'Apply Filters'}></GradientButton>
      <div id="end-tile"></div>      
    </StyledFilterSection>
  );
}
